import React, { PureComponent } from 'react';

import PropTypes from 'prop-types';
import SvgError from '../../../../assets/svgs/error.svg';
import classNames from 'classnames/bind';
import styles from './styles.module.scss';

const cx = classNames.bind(styles);

class Input extends PureComponent {
  render() {
    const {
      value = '',
      maxLength,
      disabled,
      fullWidth,
      className,
      innerRef,
      errorText,
      innerText,
      ...props
    } = this.props;

    return (
      <>
        <div className={cx('input-container')}>
          <input
            value={value}
            className={cx('Input', { disabled, fullWidth, errorText }, className)}
            disabled={disabled}
            maxLength={maxLength}
            {...props}
            ref={innerRef}
          />
          <span>{innerText}</span>
        </div>
        <div className={cx('options')}>
          {errorText && (
            <div className={cx('error-text')}>
              <SvgError />
              {errorText}
            </div>
          )}
          {maxLength ? (
            <>
              <div></div>
              <div className={cx('max-length')}>
                {value.length || 0}/{maxLength}
              </div>
            </>
          ) : null}
        </div>
      </>
    );
  }
}

Input.propTypes = {
  disabled: PropTypes.bool,
  fullWidth: PropTypes.bool,
};

export default React.forwardRef((props, ref) => <Input innerRef={ref} {...props} />);
